import { Button } from "@sproutsocial/seeds-react-button";
import type { TypeSimplePaginationConfig } from "./DataTableTypes";
import { StyledShowMoreButtonsRow } from "./styles";

interface SimplePaginationProps {
  simplePaginationConfig: TypeSimplePaginationConfig;
  onChangePageSize: (newPageSize: number) => void;
  rowsLength: number;
  dataLength: number;
}

export const SimplePagination = ({
  simplePaginationConfig,
  onChangePageSize,
  rowsLength,
  dataLength,
}: SimplePaginationProps) => {
  const { initialVisibleRows, expandBy = initialVisibleRows } =
    simplePaginationConfig;

  const shouldShowMoreButton = rowsLength < dataLength;
  const shouldShowLessButton = rowsLength > initialVisibleRows;
  const shouldShowAllButton =
    simplePaginationConfig.displayShowAllButton && rowsLength < dataLength;

  const handleShowMore = () => {
    onChangePageSize(rowsLength + expandBy);
  };

  const handleShowLess = () => {
    onChangePageSize(initialVisibleRows);
  };

  const handleShowAll = () => {
    onChangePageSize(dataLength);
  };

  return (
    <StyledShowMoreButtonsRow>
      {shouldShowMoreButton && (
        <Button appearance="secondary" onClick={handleShowMore}>
          {simplePaginationConfig.showMoreText}
        </Button>
      )}
      {shouldShowLessButton && (
        <Button appearance="secondary" onClick={handleShowLess}>
          {simplePaginationConfig.showLessText}
        </Button>
      )}
      {shouldShowAllButton && (
        <Button appearance="secondary" onClick={handleShowAll}>
          {simplePaginationConfig.showAllText}
        </Button>
      )}
    </StyledShowMoreButtonsRow>
  );
};
